import { PdPopup } from "./pd-popup/PdPopup.js";
//#region src/pd-popup/pd-popup.ts
var tag = "pd-popup";
if (!customElements.get(tag)) customElements.define(tag, PdPopup);
//#endregion
export { PdPopup };
